import httpRequest from '@/utils/request'

// 转库单列表
export function getTransferList(data: any): Promise<any> {
  return httpRequest({
    url: '/ext/wTransferExt/pageList',
    method: 'post',
    data
  })
}

// 转库单详情
export function wTransferExtDetail(id: any): Promise<any> {
    return httpRequest({
        url:  `/ext/wTransferExt/${id}`,
        method: 'get'
    })
}

// 分页查询库存
export function getwStockExtList(data: any): Promise<any> {
  return httpRequest({
    url: '/ext/wStockExt/pageForH5',
    method: 'post',
    data
  })
}

// 出入库单列表
export function getBoundList(data: any): Promise<any> {
  return httpRequest({
    url: '/ext/wOutboundExt/listPage',
    method: 'post',
    data
  })
}

// 提交转库单出入库
export function inOutSubmit(params: any): Promise<any> {
  return httpRequest({
    url: 'ext/wTransferExt/wTransferForInOutUpload',
    method: 'get',
    params
  })
}

// 出入库列表统计 - H5
export function pageCount(data: any): Promise<any> {
  return httpRequest({
    url: 'ext/wOutboundExt/pageCount',
    method: 'post',
    data
  })
}

// 转库列表统计 - H5
export function ZKPageCount(data: any): Promise<any> {
  return httpRequest({
    url: 'ext/wTransferExt/pageCount',
    method: 'post',
    data
  })
}

/**
 *
 * @param params id 出入库id
 * @returns
 */
export function getBoundDetail(params: any): Promise<any> {
  return httpRequest({
    url: '/ext/wOutboundExt/findById',
    method: 'get',
    params
  })
}
/**
 * 取消出入库单据
 * @param params id 出入库id
 * @returns
 */
export function cancelBound(params: any): Promise<any> {
  return httpRequest({
    url: '/ext/wOutboundExt/cancel',
    method: 'get',
    params
  })
}
